<template>
<!-- 三大服务-配镜 -->
    <div class="content">
        <div class="eye">
            <img class="pic" src="../assets/touxiang@2x.png" alt="pic">
            <div class="title">视光配镜专家</div>
            <!-- <div class="container"> -->
                <p>从2000年开始从事眼镜至今，拥有二十年多专业验光配镜经验，累计接待近视患者二十多万人次，精通验光配镜的各个环节，具有非常丰富的实践经验。精通眼镜行业的各个环节及各种商业模式。</p>
                <p>2008年国内第一个眼镜主题商城，</p>
                <p>2009年在上海开第二家眼镜主题商城</p>
                <p>2012开发在线试戴系统《眼镜试戴王》</p>
                <p>2013年创办北京五品文化有限公司，开始研发智能眼镜。</p>
            <!-- </div> -->
            
        </div>
        <div class="QRcodeBox">
            <!-- <div class="QRcode"></div> -->
            <img class="QRcode" src="../assets/erweima@2x.png">
        </div>

        <div class="card">
            <div>扫码进群</div>
            <div>仅限500人</div>
            <div>开放时间：周三上午9:00~11:00</div>

            <div>
                上次讨论纪要：1.
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

    },
    components: {

    },
};
</script>

<style scoped>
.content {
    padding: 28px;
}
.eye {
    padding: 28px;
    background: #fff;
    border-radius: 25px;
}
.eye .pic {
    width: 150px;
    height: 150px;
    /* background: #c34a45; */
    border-radius: 50%;
    display: block;
    margin: 0 auto 40px;
}
.eye .title {
    text-align: center;
    letter-spacing: 4px;
    margin-bottom: 60px;
}

.eye p {
    line-height: 68px;
}

.eye p span.mafan {
    display: inline-block;
    width: 140px;
    text-align: justify;
    text-align-last: justify;
}

.top {
    margin-top: 66px;
}

.QRcodeBox {
    width: 252px;
    height: 252px;
    background: #fff;
    margin: 28px auto;
    padding: 28px;
    border-radius: 25px;
}

.QRcode {
    width: 100%;
    height: 100%;
    /* background: #c34a45; */
}

.card {
    padding: 28px;
    background: #fff;
    text-align: center;
    margin-bottom: 26px;
}

.card div{
    margin-bottom: 26px;
}

.card div:nth-of-type(2) {
    font-size: 34px;
    color: #c34a45;
}

.card div:last-of-type {
    text-align: left;
}

.container {
    height: 360px;
    padding: 0 20px;
    border: 2px dashed #c34a45;
    border-radius: 10px;
    overflow-y: scroll;
}
</style>


// WEBPACK FOOTER //
// src/views/Optician.vue